export const APPLICATIONS_TAGS = {
  list: "forms-list",
  pending: "pending-actions-list",
};
export const AUTH_TAGS = {
  profile: "profile",
};
